import { usePropertyGeneralContractorWillWork } from '../../../queries/PropertyFields/NonRentalFlagFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';

interface GeneralContractorProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const GeneralContractor: React.FC<GeneralContractorProps> = ({ propertyGuid, required = false, isReview = false }) => {
    const label = 'Will a third-party General Contractor work on this?';
    const [generalContractorWillWork, set_generalContractorWillWork] = usePropertyGeneralContractorWillWork(propertyGuid);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_generalContractorWillWork(true);
                return;
            case 'no':
                set_generalContractorWillWork(false);
                return;
            default:
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={generalContractorWillWork ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='toggleButtonGeneralContractorWillWork'
                    value={generalContractorWillWork}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='General Contractor required'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
